const themeOverrides = {
  typography: {
    fontFamily: "vazirMedium",
    h1: {
      fontSize: "32px",
      fontFamily: "vazirBold",
      fontWeight: "normal",
    },
    h2: {
      fontSize: "24px",
      fontFamily: "vazirBold",
      fontWeight: "normal",
    },
    h3: {
      fontSize: "18px",
      fontFamily: "vazirBold",
      fontWeight: "normal",
    },
    h4: {
      fontSize: "16px",
      fontFamily: "vazirBold",
      fontWeight: "normal",
    },
    h5: {
      fontSize: "14px",
      fontFamily: "vazirBold",
      fontWeight: "normal",
    },
    h6: {
      fontSize: "12px",
      fontFamily: "vazirBold",
      fontWeight: "normal",
    },
    body1: {
      fontSize: "16px",
      fontWeight: "normal",
    },
    body2: {
      fontSize: "14px",
      fontWeight: "normal",
    },
    subtitle1: {
      fontSize: "12px",
      fontWeight: "normal",
    },
    caption: {
      fontSize: "8px",
      fontWeight: "normal",
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        textSizeSmall: {
          fontSize: 14,
          height: "32px",
          borderRadius: "12px",
        },
        containedSizeMedium: {
          fontSize: 14,
          height: "48px",
          borderRadius: "12px",
        },
        containedSizeSmall: {
          fontSize: 14,
          height: "32px",
          borderRadius: "8px",
        },
        outlinedSizeSmall: {
          fontSize: 14,
          height: "32px",
          borderRadius: "8px",
        },
        outlinedSizeMedium: {
          fontSize: 14,
          height: "48px",
        },
      },
    },
    MuiTextField: {
      defaultProps: {},
      styleOverrides: {
        root: {
          "& input": { fontSize: "14px" },
          "& .MuiOutlinedInput-root fieldset": {
            borderRadius: "8px",
            borderColor: "#797979",
            borderWidth: "1px",
          },
          "& .MuiOutlinedInput-root.Mui-focused fieldset": {
            borderRadius: "8px",
            borderColor: "#593be2",
            borderWidth: "1px",
          },
          "& .Mui-disabled fieldset": {
            backgroundColor: "rgba(0,0,0,0.05)",
          },
          "& .Mui-error": {
            color: "#e2222e",
          },
          "& .Mui-error fieldset": {
            backgroundColor: "rgba(226,34,46,0.2)",
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "12px",
        },
      },
    },
  },
};

export default themeOverrides;
